/**
 * Email Campaigns Tab
 * Coming Soon placeholder
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { Email as EmailIcon } from '@mui/icons-material';

const EmailCampaignsTab: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 400, textAlign: 'center' }}>
      <EmailIcon sx={{ fontSize: 64, color: 'grey.400', mb: 2 }} />
      <Typography variant="h5" gutterBottom>Email Campaign</Typography>
      <Typography variant="body1" color="text.secondary">Coming Soon</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        We're building powerful email campaign tools. Stay tuned!
      </Typography>
    </Box>
  );
};

export default EmailCampaignsTab;
